import { twMerge } from 'tailwind-merge';
import Box from '@/components/Box';
import { classes, styles } from './utils';

export interface TextFieldProps {
  autoFocus?: boolean;
  autoComplete?: string;
  className?: string;
  type?: 'text' | 'email' | 'password';
  variant?: 'default' | 'compact';
  name?: string;
  label: string;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
}

export default function TextField({
  autoFocus,
  autoComplete,
  className,
  type = 'text',
  variant = 'default',
  name,
  label,
  value,
  placeholder = ' ', // blank space required for :placeholder-shown to toggle the floated label
  onChange,
}: TextFieldProps) {
  const isCompact = variant === 'compact';
  return (
    <Box
      sx={styles.field}
      className={twMerge(
        classes.field,
        isCompact ? classes.compact : classes.default,
        className
      )}
      component="label">
      <span
        className={twMerge(classes.label, isCompact && classes.labelCompact)}>
        {label}
      </span>
      <input
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        className={twMerge(
          classes.input,
          isCompact && classes.inputCompact,
          type === 'password' && classes.password
        )}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder || ' '}
        onChange={(e) => onChange(e.target.value)}
      />
    </Box>
  );
}
